
export default {
  name: 'AtomSidebarTitle',
  props: {
    title: {
      required: true,
      type: String,
      default: ''
    }
  }
}
